import { memo, useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { BzButton, BzChip } from '../../../components';
import { useSelector, useDispatch } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';


const TabMutualFundContent = ({ setShow, strGlobalSearchMFInputText, handleOnClickMutualFundScrip, searchData, arrGlobalScripts, mutualFund, plus, setPlus, searchValue, setAddToggle, scriptDetails, setScriptDetails, onAddWatchlist, isShowing, setBse, mutualFundsScrips, setMutualFundsScrips, ...props }) => {
    const dispatch = useDispatch();

    const removeMutualFundScrips = useCallback((e, selectedMutualFundScrip) => {
        const arrMutualFundSchemes = mutualFundsScrips;
        const nIndexFromScripDetails = arrMutualFundSchemes?.findIndex(scrip => scrip?.exchange_code === selectedMutualFundScrip?.exchange_code && scrip?.token === selectedMutualFundScrip?.token);
        if (nIndexFromScripDetails >= 0) {
            arrMutualFundSchemes.splice(nIndexFromScripDetails, 1);
        } else { }
        setMutualFundsScrips([...arrMutualFundSchemes]);
    }, [mutualFundsScrips]);

    const addMutualFundScrips = useCallback((e, selectedMutualFundScrip) => {
        setMutualFundsScrips(prevState => [...prevState, selectedMutualFundScrip]);
    }, []);

    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */ }
    const { data: mfScrips, count } = useSelector(store => store.globalSearch.searchMFScrips);

    const handlePlaceOrder = (orderType) => {
        dispatch(handleModal([{ 'PLACE_MUTUAL_FUND_ORDER': true }]));
        dispatch(handleModalData({ orderType }));
        setShow(false);
    };
    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */ }

    return (
        <div className='pt-4'>
            <div className='mb-4 font-regular font-size2 color-subtext'>{count} results</div>
            <Row className='g-0 mt-4'>
                {mfScrips?.length > 0 && mfScrips.map((element, i) => (
                    <Row onClick={() => handleOnClickMutualFundScrip(element)} className='g-0 pb-3 mb-3'>
                        <Col md={7} className='pe-5 flex-column justify-content-start'>
                            <div className='font-medium font-size4 color-text mb-1'>{element?.scheme_name}</div>
                            <div className='chips-wrap flex-wrap'>
                                {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */}
                                <BzChip className='chips primary-chip font-medium font-size2 text-uppercase me-2 mb-2'>{element?.scheme_type}</BzChip>
                                <BzChip className='chips primary-chip font-medium font-size2 text-uppercase me-2 mb-2'>{element?.option_name}</BzChip>
                                {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */}
                            </div>
                        </Col>
                        <Col className='flex-column justify-content-center align-self-center'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-regular font-size2 color-subtext'>NAV</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <div className='font-medium font-size4 color-text'>&#8377;{element?.nav}</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={3} className='d-flex justify-content-end align-items-center'>
                            {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */}
                            <BzButton onClick={() => handlePlaceOrder('SIP')} className='btn btn-outline btn-md'>SIP</BzButton>
                            <BzButton onClick={() => handlePlaceOrder('BUY')} className='btn btn-positive btn-md ms-3'>BUY</BzButton>
                            {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */}
                            {
                                mutualFundsScrips?.some(eachMutualFund => eachMutualFund?.exchange_code + '_' + eachMutualFund?.scheme_code === element?.exchange_code + '_' + element?.scheme_code) ?
                                    <div onClick={(e) => removeMutualFundScrips(e, element)} className='icon-24 icon-minus-circle icon-dark ms-3'></div>
                                    : <div onClick={(e) => addMutualFundScrips(e, element)} className='icon-24 icon-add-circle icon-dark ms-3'></div>
                            }
                        </Col>
                    </Row>
                ))}
            </Row>
        </div>
    );

};

export default memo(TabMutualFundContent);